function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var ChangesGraphicSvg = function ChangesGraphicSvg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 144 144"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fillOpacity: 0,
    fill: "#D8D8D8",
    d: "M0 0h144v144H0z"
  }), React.createElement("path", {
    d: "M118.5 42c0-5.799-4.701-10.5-10.5-10.5S97.5 36.201 97.5 42v1.5h-57v54h69v-.12c5.087-.729 9-5.092 9-10.38 0-.51-.048-1.008-.118-1.5h.118V42z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M97.5 87c0-5.799 4.701-10.5 10.5-10.5s10.5 4.701 10.5 10.5-4.701 10.5-10.5 10.5H40.5v-54H96",
    stroke: "#3A3A3A",
    strokeWidth: 3
  }), React.createElement("path", {
    d: "M97.5 87V42c0-5.799 4.701-10.5 10.5-10.5s10.5 4.701 10.5 10.5v45",
    stroke: "#3A3A3A",
    strokeWidth: 3
  }), React.createElement("path", {
    fill: "#F6682F",
    d: "M25.5 99h9V52.5h-9z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M34.5 99v6l-4.5 6-4.5-6v-6"
  }), React.createElement("path", {
    stroke: "#3A3A3A",
    strokeWidth: 3,
    d: "M34.5 52.5V105l-4.5 6-4.5-6V52.5M25.5 99h9"
  }), React.createElement("path", {
    d: "M25.5 48c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v4.5h-9V48z",
    fill: "#D2D6DF"
  }), React.createElement("path", {
    d: "M25.5 48c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v4.5h-9V48zM30 111v3",
    stroke: "#3A3A3A",
    strokeWidth: 3
  }), React.createElement("path", {
    fill: "#D2D6DF",
    d: "M79.5 76.5h9v-9h-9zM64.5 76.5h9v-9h-9z"
  }), React.createElement("path", {
    stroke: "#3A3A3A",
    strokeWidth: 3,
    d: "M79.5 76.5h9v-9h-9zM64.5 76.5h9v-9h-9zM78 82.5h12M78 88.5h12M63 82.5h12M63 88.5h12"
  }), React.createElement("path", {
    fill: "#D2D6DF",
    d: "M49.5 76.5h9v-9h-9z"
  }), React.createElement("path", {
    stroke: "#3A3A3A",
    strokeWidth: 3,
    d: "M49.5 76.5h9v-9h-9zM48 82.5h12M48 88.5h12"
  }), React.createElement("path", {
    fill: "#D2D6DF",
    d: "M49.5 61.5h39v-9h-39z"
  }), React.createElement("path", {
    stroke: "#3A3A3A",
    strokeWidth: 3,
    d: "M49.5 61.5h39v-9h-39z"
  }), React.createElement("path", {
    fill: "#3A3A3A",
    d: "M39 105h81v-3H39z"
  }), React.createElement("path", {
    fill: "#F6682F",
    d: "M39 114h81v-9H39z"
  }), React.createElement("path", {
    d: "M112.5 114v-6M106.5 114v-3M100.5 114v-3M94.5 114v-6M88.5 114v-3M82.5 114v-3M76.5 114v-6M70.5 114v-3M64.5 114v-3M58.5 114v-6M52.5 114v-3M46.5 114v-3",
    stroke: "#3A3A3A",
    strokeWidth: 3
  })));
};

ChangesGraphicSvg.displayName = "ChangesGraphicSvg";
export default ChangesGraphicSvg;